import script from "./StudentDetailsDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentDetailsDialog.vue?vue&type=script&setup=true&lang=js"

import "./StudentDetailsDialog.vue?vue&type=style&index=0&id=8fdffd40&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8fdffd40"]])

export default __exports__